import { FC } from 'react';

import { Link } from '@dbt-labs/sourdough';

import { useDbtCloudProject } from '@/context/DbtCloudProjectProvider';
import { useProject } from '@/hooks/admin/project';
import { useLinkToDbtCloud } from '@/hooks/links';

type ProjectDescriptionBannerProps = {
  showHeader?: boolean;
};

export const ProjectDescriptionBanner: FC<ProjectDescriptionBannerProps> = ({
  showHeader = true,
}) => {
  const { accountId, projectId } = useDbtCloudProject();
  const projectDescription = useProject({
    accountId,
    projectId,
  }).data?.description;
  const hasNonEmptyDescription =
    projectDescription != null && projectDescription.length > 0;
  const projectSettings = useLinkToDbtCloud('projectSettings');
  return (
    <>
      <span className="inline-block w-full min-w-[160px] flex-1 overflow-hidden rounded-lg border border-borderMuted bg-bgBackground">
        <div className="m-4">
          {showHeader && (
            <div className="text-md flex font-semibold text-fgAlt">
              <span className="flex-1 truncate">Project description</span>
            </div>
          )}
          <div className="text-sm text-fgMain">
            {hasNonEmptyDescription && projectDescription}
            {!hasNonEmptyDescription && (
              <p>
                A description does not exist for this project. Users with admin
                permissions can add it in the{' '}
                {projectSettings ? (
                  <Link
                    isInternal={false}
                    shouldOpenNewTab
                    to={projectSettings({
                      accountId,
                      projectId,
                    })}
                  >
                    project settings
                  </Link>
                ) : (
                  <>dbt Cloud project settings</>
                )}
                .
              </p>
            )}
          </div>
        </div>
      </span>
    </>
  );
};
